import { render, staticRenderFns } from "./ResultsView.vue?vue&type=template&id=32350fb6&scoped=true"
import script from "./ResultsView.vue?vue&type=script&lang=js"
export * from "./ResultsView.vue?vue&type=script&lang=js"
import style0 from "./ResultsView.vue?vue&type=style&index=0&id=32350fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32350fb6",
  null
  
)

export default component.exports